import apiConfig from '../../../../../config/api'
import { apiRequestorHelper } from '../../../../../helpers'

export const getBeneficiariesMatches = (idsForMatches) => {
    return apiRequestorHelper({
        url: apiConfig.url + '/getCommonUbos',
        method: 'post',
        body: idsForMatches
    })
}